import keyMirror from 'keymirror';

const TableGroupingOptions = keyMirror({
  SECTION: null,
  SERVER: null,
  TOPSIZE: null,
});

interface KeyAndDefaultByGroupingOptionType {
  [grouping: string]: {
    key: string;
    defaultText: string;
  };
}

interface ISelectTableGroupingOptions {
  [grouping: string]: {
    key: string;
    id: string;
    label: string;
  };
}

export const KeyAndDefaultByGroupingOption: KeyAndDefaultByGroupingOptionType = {
  [TableGroupingOptions.SECTION]: {
    key: 'section',
    defaultText: 'Default section',
  },
  [TableGroupingOptions.SERVER]: {
    key: 'serverName',
    defaultText: 'No server',
  },
  [TableGroupingOptions.TOPSIZE]: {
    key: 'size',
    defaultText: 'Unknown',
  },
};

export const SelectTableGroupingOptions: ISelectTableGroupingOptions = {
  [TableGroupingOptions.SECTION]: {
    key: TableGroupingOptions.SECTION,
    id: TableGroupingOptions.SECTION,
    label: 'Sort by section',
  },
  [TableGroupingOptions.SERVER]: {
    key: TableGroupingOptions.SERVER,
    id: TableGroupingOptions.SERVER,
    label: 'Sort by server',
  },
  [TableGroupingOptions.TOPSIZE]: {
    key: TableGroupingOptions.TOPSIZE,
    id: TableGroupingOptions.TOPSIZE,
    label: 'Sort by top size',
  },
};

export default TableGroupingOptions;
